module.exports = __webpack_public_path__ + "static/media/cookie-the-pom-gySMaocSdqs-unsplash.e9a44832.jpg";